module.exports = __webpack_public_path__ + "img/crystalheart_i_m.8d28bc06.jpg";